<template>
  <div class="word-list">
    <div class="content">
      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateSameWord"
          v-model="checkAllSameWord"
          @change="handleCheckAllSameWordChange"
          class="title"
          :disabled="sameWord.length === 0"
          >同义词</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedSameWord"
          @change="handleSameWordChange"
        >
          <el-checkbox v-for="word in sameWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateSimilarWord"
          v-model="checkAllSimilarWord"
          @change="handleCheckAllSimilarWordChange"
          class="title"
          :disabled="similarWord.length === 0"
          >近义词</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedSimilarWord"
          @change="handleSimilarWordChange"
        >
          <el-checkbox v-for="word in similarWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>

      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateUpperWord"
          v-model="checkAllUpperWord"
          @change="handleCheckAllUpperWordChange"
          class="title"
          :disabled="upperWord.length === 0"
          >上位词</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedUpperWord"
          @change="handleUpperWordChange"
        >
          <el-checkbox v-for="word in upperWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateLowerWord"
          v-model="checkAllLowerWord"
          @change="handleCheckAllLowerWordChange"
          class="title"
          :disabled="lowerWord.length === 0"
          >下位词</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedLowerWord"
          @change="handleLowerWordChange"
        >
          <el-checkbox v-for="word in lowerWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateKeyWord"
          v-model="checkAllKeyWord"
          @change="handleCheckAllKeyWordChange"
          class="title"
          :disabled="keyWord.length === 0"
          >关联词</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedKeyWord"
          @change="handleKeyWordChange"
        >
          <el-checkbox v-for="word in keyWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="word-column">
        <el-checkbox
          :indeterminate="isIndeterminateModernWord"
          v-model="checkAllModernWord"
          @change="handleCheckAllMordernWordChange"
          class="title"
          :disabled="modernWord.length === 0"
          >现代医学用语</el-checkbox
        >
        <el-checkbox-group
          v-model="checkedModernWord"
          @change="handleModernWordChange"
        >
          <el-checkbox v-for="word in modernWord" :label="word" :key="word">{{
            word
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="footer">
      <button class="confirm-button" @click="handleConfirm">确认</button>
      <button class="cancel-button" @click="handleCancel">取消</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WordList",
  props: {
    wordList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sameWord: [],
      checkedSameWord: [],
      checkAllSameWord: true,
      isIndeterminateSameWord: false,
      similarWord: [],
      checkedSimilarWord: [],
      checkAllSimilarWord: true,
      isIndeterminateSimilarWord: false,
      upperWord: [],
      checkedUpperWord: [],
      checkAllUpperWord: false,
      isIndeterminateUpperWord: false,
      lowerWord: [],
      checkedLowerWord: [],
      checkAllLowerWord: false,
      isIndeterminateLowerWord: false,
      keyWord: [],
      checkedKeyWord: [],
      checkAllKeyWord: false,
      isIndeterminateKeyWord: false,
      modernWord: [],
      checkedModernWord: [],
      checkAllModernWord: false,
      isIndeterminateModernWord: false
    };
  },
  watch: {
    wordList(val) {
      console.log(val);
      let sameWordList = [];
      let similarWordList = [];
      let upperWordList = [];
      let lowerWordList = [];
      let keyWordList = [];
      let modernWordList = [];
      // 清空数据
      this.sameWord = [];
      this.checkedSameWord = [];
      this.checkAllSameWord = true;
      this.isIndeterminateSameWord = false;
      this.similarWord = [];
      this.checkedSimilarWord = [];
      this.checkAllSimilarWord = true;
      this.isIndeterminateSimilarWord = false;
      this.upperWord = [];
      this.checkedUpperWord = [];
      this.checkAllUpperWord = false;
      this.isIndeterminateUpperWord = false;
      this.lowerWord = [];
      this.checkedLowerWord = [];
      this.checkAllLowerWord = false;
      this.isIndeterminateLowerWord = false;
      this.keyWord = [];
      this.checkedKeyWord = [];
      this.checkAllKeyWord = false;
      this.isIndeterminateKeyWord = false;
      this.modernWord = [];
      this.checkedModernWord = [];
      this.checkAllModernWord = false;

      //   let appended = []

      val.forEach(element => {
        // console.log(this.$global.wordList[element])
        if (element in this.$global.wordList) {
          //   appended.push(element)
          for (let i = 0; i < this.$global.wordList[element].same.length; i++) {
            if (
              sameWordList.indexOf(this.$global.wordList[element].same[i]) ===
              -1
            ) {
              sameWordList.push(this.$global.wordList[element].same[i].trim());
            }
          }

          for (
            let i = 0;
            i < this.$global.wordList[element].similar.length;
            i++
          ) {
            if (
              similarWordList.indexOf(
                this.$global.wordList[element].similar[i]
              ) === -1
            ) {
              similarWordList.push(
                this.$global.wordList[element].similar[i].trim()
              );
            }
          }

          for (let i = 0; i < this.$global.wordList[element].up.length; i++) {
            if (
              upperWordList.indexOf(this.$global.wordList[element].up[i]) === -1
            ) {
              upperWordList.push(this.$global.wordList[element].up[i].trim());
            }
          }

          for (let i = 0; i < this.$global.wordList[element].down.length; i++) {
            if (
              lowerWordList.indexOf(this.$global.wordList[element].down[i]) ===
              -1
            ) {
              lowerWordList.push(this.$global.wordList[element].down[i].trim());
            }
          }

          for (let i = 0; i < this.$global.wordList[element].ref.length; i++) {
            if (
              keyWordList.indexOf(this.$global.wordList[element].ref[i]) === -1
            ) {
              keyWordList.push(this.$global.wordList[element].ref[i].trim());
            }
          }

          for (
            let i = 0;
            i < this.$global.wordList[element].modern.length;
            i++
          ) {
            if (
              modernWordList.indexOf(
                this.$global.wordList[element].modern[i]
              ) === -1
            ) {
              modernWordList.push(
                this.$global.wordList[element].modern[i].trim()
              );
            }
          }
          //   sameWordList.push(...this.$global.wordList[element].same)
          //   similarWordList.push(...this.$global.wordList[element].similar)
          //   upperWordList.push(...this.$global.wordList[element].up)
          //   lowerWordList.push(...this.$global.wordList[element].down)
          //   keyWordList.push(...this.$global.wordList[element].ref)
          //   modernWordList.push(...this.$global.wordList[element].modern)
        }
      });

      val.forEach(element => {
        for (let i = 0; i < sameWordList.length; i++) {
          if (sameWordList[i] === element) {
            sameWordList.splice(i, 1);
          }
        }

        for (let i = 0; i < similarWordList.length; i++) {
          if (similarWordList[i] === element) {
            similarWordList.splice(i, 1);
          }
        }

        for (let i = 0; i < upperWordList.length; i++) {
          if (upperWordList[i] === element) {
            upperWordList.splice(i, 1);
          }
        }

        for (let i = 0; i < lowerWordList.length; i++) {
          if (lowerWordList[i] === element) {
            lowerWordList.splice(i, 1);
          }
        }

        for (let i = 0; i < keyWordList.length; i++) {
          if (keyWordList[i] === element) {
            keyWordList.splice(i, 1);
          }
        }

        for (let i = 0; i < modernWordList.length; i++) {
          if (modernWordList[i] === element) {
            modernWordList.splice(i, 1);
          }
        }
      });

      this.sameWord = sameWordList;
      if(sameWordList.length === 0) {
        this.checkAllSameWord = false;
      }
      this.checkedSameWord = sameWordList;
      this.similarWord = similarWordList;
      if (similarWordList.length === 0) {
        this.checkAllSimilarWord = false;
      }
      this.checkedSimilarWord = similarWordList;
      this.upperWord = upperWordList;

      this.lowerWord = lowerWordList;

      this.keyWord = keyWordList;

      this.modernWord = modernWordList;
    }
  },
  methods: {
    handleCheckAllSameWordChange(val) {
      this.checkedSameWord = val ? this.sameWord : [];
      this.isIndeterminateSameWord = false;
    },
    handleSameWordChange(value) {
      let checkedCount = value.length;
      this.checkAllSameWord = checkedCount === this.sameWord.length;
      this.isIndeterminateSameWord =
        checkedCount > 0 && checkedCount < this.sameWord.length;
    },
    handleCheckAllSimilarWordChange(val) {
      this.checkedSimilarWord = val ? this.similarWord : [];
      this.isIndeterminateSimilarWord = false;
    },
    handleSimilarWordChange(value) {
      let checkedCount = value.length;
      this.checkAllSimilarWord = checkedCount === this.similarWord.length;
      this.isIndeterminateSimilarWord =
        checkedCount > 0 && checkedCount < this.similarWord.length;
    },
    handleCheckAllUpperWordChange(val) {
      this.checkedUpperWord = val ? this.upperWord : [];
      this.isIndeterminateUpperWord = false;
    },
    handleUpperWordChange(value) {
      let checkedCount = value.length;
      this.checkAllUpperWord = checkedCount === this.upperWord.length;
      this.isIndeterminateUpperWord =
        checkedCount > 0 && checkedCount < this.upperWord.length;
    },
    handleCheckAllLowerWordChange(val) {
      this.checkedLowerWord = val ? this.lowerWord : [];
      this.isIndeterminateLowerWord = false;
    },
    handleLowerWordChange(value) {
      let checkedCount = value.length;
      this.checkAllLowerWord = checkedCount === this.lowerWord.length;
      this.isIndeterminateLowerWord =
        checkedCount > 0 && checkedCount < this.lowerWord.length;
    },
    handleCheckAllKeyWordChange(val) {
      this.checkedKeyWord = val ? this.keyWord : [];
      this.isIndeterminateKeyWord = false;
    },
    handleKeyWordChange(value) {
      let checkedCount = value.length;
      this.checkAllKeyWord = checkedCount === this.keyWord.length;
      this.isIndeterminateKeyWord =
        checkedCount > 0 && checkedCount < this.keyWord.length;
    },
    handleCheckAllMordernWordChange(val) {
      this.checkedModernWord = val ? this.modernWord : [];
      this.isIndeterminateModernWord = false;
    },
    handleModernWordChange(value) {
      let checkedCount = value.length;
      this.checkAllModernWord = checkedCount === this.modernWord.length;
      this.isIndeterminateModernWord =
        checkedCount > 0 && checkedCount < this.modernWord.length;
    },
    handleConfirm() {
      this.$emit("confirm", {
        sameWord: this.checkedSameWord,
        similarWord: this.checkedSimilarWord,
        upperWord: this.checkedUpperWord,
        lowerWord: this.checkedLowerWord,
        keyWord: this.checkedKeyWord,
        modernWord: this.checkedModernWord
      });
    },
    handleCancel() {
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped>
.word-list {
  min-width: max-content;
  height: 303px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #f7f6f5;
  border-top: 2px solid #9e5c1d;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 13px;
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex: 1 1 auto;
  overflow-y: scroll;
  /* overflow-x: scroll; */
  margin-bottom: 10px;
  min-width: 772px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.confirm-button {
  width: 100px;
  height: 40px;
  background: #9e5c1d;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

.cancel-button {
  width: 100px;
  height: 40px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  color: #9e5c1d;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #9e5c1d;
  cursor: pointer;
}

.word-list >>> .el-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.word-list >>> .el-checkbox__inner {
  border: 1px solid #634c37;
  border-radius: 0;
}

.word-list >>> .el-checkbox__label {
  color: #634c37;
}

.word-list >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.word-list >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #9e5c1d;
  border-color: #9e5c1d;
}

.word-list >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #634c37;
}

.word-column {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto; */
  min-width: 100px;
}

.word-list >>> .title .el-checkbox__label {
  font-weight: bold;
  color: #634c37;
}

.title {
  padding-bottom: 10px;
  width: 100%;
}

.words {
  width: 84px;
  height: 14px;
  font-size: 14px;
  color: #634c37;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/WordList.vue